if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"core_hr","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(3(032|283|561)|4((04|08|72)9|135)|6(136|587|995)|2033|2311|7399|7596|8859|9427)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}